<template>
<modal
    :title="$t('PIM_PHARMACY-MODAL_TITLE-VERBOSE_CALCULATION')"
    :width="520"
    cancel-text="Schließen"
    transition="fadeDown"
    :show-ok="false"
    :is-show="showModal"
    :backdrop-closable="false"
    @close="handleClose"
    class="vcenter">

    <template v-if="informationData">
        <div class="calculation">
        <span class="block">
            <span class="label"><lang labelKey="LOYALTY_POINTS-VERBOSE_CALCULATION-PRICE"></lang></span>
            <span class="value">€ {{ formatPoint2Comma(informationData.price) }}</span>
        </span>

        <span class="operator"> * </span>

        <span class="block">
            <span class="label"><lang labelKey="LOYALTY_POINTS-VERBOSE_CALCULATION-CONVERSION_RATE"></lang></span>
            <span class="value">{{ informationData.conversionRate }}</span>
        </span>

         <span class="operator"> * </span>

        <span class="block">
            <span class="label"><lang labelKey="LOYALTY_POINTS-VERBOSE_CALCULATION-MULTIPLIER"></lang></span>
            <span class="value">{{ multiplierList && multiplierList.length > 0 ? multiplierList[0].value : 1 }}</span>
        </span>

         <span class="operator"> = </span>

        <span class="block">
            <span class="label"><lang labelKey="LOYALTY_POINTS-VERBOSE_CALCULATION-LOYALTY_POINTS"></lang></span>
            <span class="value">{{loyaltyPoints }}</span>
        </span>
        </div>

        <div class="multipliers">
            <div v-for="multiplier in multiplierList" :key="multiplier.name" class="multiplier">
                <span class="name">{{ multiplier.object && multiplier.object.name ? multiplier.object.name : 'default'}}</span>
                <span class="type"><lang :labelKey="`LOYALTY_POINTS_TYPE-${multiplier.type && multiplier.type.toUpperCase()}`"></lang></span>
                <span class="value">{{ multiplier.value }}&nbsp;({{ Math.round(informationData.basePoints * multiplier.value) }})</span>
            </div>
        </div>
    </template>
</modal>

</template>   


<script>
export default {
  name: 'VerboseCalculationModal',
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    informationData: {
        type: Object,
        required: false
    },
    loyaltyPoints: {
      type: Number,
      required: true
    }
  },

  data() {
    return {

    };
  },



  created() {
    // console.log('informationData in Modal:', this.informationData);
  },

  computed: {

    multiplierList() {
      return this.informationData.multipliers || [];
    }

  },



  methods: {

    handleClose() {
      // this.$emit('update:showModal', false);
      this.$emit('close');
    },


    formatPoint2Comma(val) {
      if (val == null || val === '') return '';
      let num = Number(val);
      if (isNaN(num)) return '';
      return num.toFixed(2).replace('.', ',');
    }

  }
}
</script>

<style scoped lang="scss">

.calculation {
  display: flex;
  align-items: center;
   
  flex-direction: row; 
  gap: 0 2px;
  font-size: 16px;
  margin-bottom: 24px;


  span {
    display: block;
    margin: 0 !important;
    &.operator {
        display: flex;
        align-items: center;
        padding: 0 4px;
    }
  }

  .block {
    border-radius: 4px;
    padding: 8px 16px;
    /*min-width: 80px;*/
    text-align: center;
    background-color: #F0F0F0;

    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1px 0;

    span.value {
      font-size: 16px;
      font-weight: 600;
    }
    span.label {
      font-size: 11px;
      font-weight: 400;
      color: #666;
      text-transform: uppercase;
    }
  }
}

.multipliers {

  .multiplier {
    display: flex;
    font-size: 14px;
    margin-bottom: 6px;
    gap: 0 8px;

    &:first-child {
      font-weight: 600;
      padding-bottom: 6px;
      border-bottom: 1px solid #ddd;
    }

    &:not(:first-child) {
      color: #888;
    }
    span {
      display: block;
      margin: 0 !important;
      flex: 1;
    }
  }
}

</style>